import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
const packageIncludes = ['Volume 1 — Fundamentals & Foundations — 25 Lessons', 'Volume 2 — Strokes & Techniques — 25 Lessons', 'Volume 3 — Strategy & Tactics — 25 Lessons', 'Volume 4 — Doubles Play — 25 Lessons', 'Volume 5 — Drills & Skills — 25 Lessons', 'Volume 6 — Coaching & Instruction — 25 Lessons', 'Bonus 1 — 150 Pickleball Drills Library', 'Bonus 2 — 100 Common Mistakes, Coaching Cues & Corrections', 'Bonus 3 — 75 Games, Challenges & Competitive Activities', 'Bonus 4 — Player Assessment, Skill Rating & Progress Tracking System', 'Bonus 5 — 50 Done-for-You Clinics & Emergency Lesson Plans', '7-Day Money-Back Guarantee'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-199" data-mp="7utoc95wxctg">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-200" data-mp="1mgeq5rsdfagr">
        <div className="text-center mb-10" data-id="element-201" data-mp="1mhzirbv4kjbz">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-ink" data-id="element-202" data-mp="1hpg5kg0cnq7p">
            Your Complete 6-in-1 Offer Today
          </h2>
          <p className="text-forest text-sm md:text-base" data-id="element-203" data-mp="1crejdm7mnas0">
            The complete teaching system — ready for your next lesson.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gold rounded-3xl p-1 relative shadow-[0_16px_40px_rgba(20,67,42,0.18)]" data-id="element-204" data-mp="25g2c22uph2fl">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-forest text-cream-light font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-205" data-mp="1vfjn4toaavqt">
            <Sparkles size={14} data-id="element-206" data-mp="jzv062b15wq0" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-207" data-mp="fz1b35luqbvj">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-forest mb-3" data-id="element-208" data-mp="hit7td27o4a5">
              Pickleball Instructor Ready
            </h3>
            <p className="text-base text-charcoal mb-6" data-id="element-209" data-mp="meia3o5m7za5">
              Complete 6-in-1 Teaching System — 150 ready-to-teach pickleball lessons.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-sage-light border border-sage rounded-xl p-4" data-id="element-210" data-mp="chdih8t03bly">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-211" data-mp="3iife5l96hmv">
                  <Check size={16} className="text-forest shrink-0 mt-0.5" data-id="element-212" data-mp="3kyqhzm0dhc8h" />
                  <span data-id="element-213" data-mp="3kwdteq0403mg">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-214" data-mp="3pxut4i6uxk1g">
              <span className="text-lg text-charcoal line-through block mb-1" data-id="element-215" data-mp="3by24csew5dw4">$105.00</span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-216" data-mp="3fzdt6vpxxv39">
                <span className="text-2xl md:text-3xl text-ink" data-id="element-217" data-mp="3g1hwpcjxgs30">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold-dark" data-id="element-218" data-mp="2xbmwsjp8vhy2">$27.00</span>
              </div>
            </div>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-219" data-mp="2secysfnshxym">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-charcoal mb-4" data-id="element-220" data-mp="3g8ebeftud8vs">
              <span className="flex items-center gap-1.5" data-id="element-221" data-mp="3bacr5rkoj3iq">
                <Lock size={12} className="text-forest" data-id="element-222" data-mp="3p2ss8mu0srh0" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-223" data-mp="3l05u646raabd">
                <Zap size={12} className="text-forest" data-id="element-224" data-mp="3l2saotbmk05q" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-225" data-mp="2vcf271u45gn">
                <Shield size={12} className="text-forest" data-id="element-226" data-mp="3u2f2qoigrtm4" /> 7-Day Guarantee
              </span>
            </div>
            <div className="bg-cream border border-sage rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-227" data-mp="hxb3gppf5zrx">
              <Globe className="text-forest shrink-0 mt-0.5" size={14} data-id="element-228" data-mp="lxl6bthx0a2k" />
              <p className="text-[11px] text-charcoal leading-snug" data-id="element-229" data-mp="qrpcwbn9qg34">
                Pay in your local currency. The amount adjusts automatically based on your
                country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}